import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-product-add-navbar',
  imports: [CommonModule],
  templateUrl: './product-add-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-add-navbar.component.scss',
})
export class ProductAddNavbarComponent {
  translationService = inject(TranslationService)
  @Input({ required: true }) productSteps: Array<string> = []
  @Input({ required: true }) currentStep: number = 0
  @Input({ required: true }) lastVisitedStep: number = 0
  @Input() editing = false
  @Output() navigateToStep = new EventEmitter<number>()

  stepDisabled(step: number): boolean {
    return step > this.currentStep && step > this.lastVisitedStep
  }

  /**
   * Navigates to the specified step if it's not disabled.
   *
   * @param {number} step - The step number to navigate to.
   *
   */
  navigateOnClick(step: number) {
    if (!this.stepDisabled(step)) {
      this.navigateToStep.next(step)
    }
  }
}
